import { InlineTreeSelect } from '../components/InlineTreeSelect'
import { useTeamSelectOptions } from './hooks/useTeamSelectOptions'

type Props = {
  snapshotUuid: string
  value: string[]
  onChange: (value: string[]) => void
  multiSelect?: boolean
  height?: string
}

export const TeamTreeSelect = ({
  snapshotUuid,
  value,
  onChange,
  multiSelect = true,
  height = '300px',
}: Props) => {
  const { options, parentMap } = useTeamSelectOptions({
    snapshotUuid,
    selectedUuids: value,
  })

  return (
    <InlineTreeSelect
      options={options}
      parentMap={parentMap}
      value={value}
      onChange={onChange}
      multiSelect={multiSelect}
      height={height}
    />
  )
}
